import { BringzzText, BringzzButton } from "@bringzz/components";
import RocketImage from 'assets/images/Rocket.png'
import InvoiceStep from 'components/InvoiceStep'
import ShopperInvoiceStep from 'components/ShopperInvoiceStep'

export const deliverySegments = ({ navigate, loading, orderDetails }) => [
    {
        status: "On your way to the customer...",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzButton className='bg-magic-lilac mt-5' onClick={() => navigate('/map')}>Get directions</BringzzButton>
        </div>
    },
    {
        status: "You've arrived at the customer!",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Let the customer scan your QR-Code</BringzzText>
            <BringzzButton className='bg-magic-lilac mt-5' onClick={() => navigate('/qrcode')}>Identify yourself</BringzzButton>
        </div>
    },
    {
        status: "On your way to the pharmacy!",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzButton className='bg-magic-lilac mt-5' onClick={() => navigate('/map')}>Get directions</BringzzButton>
        </div>
    },
    {
        status: "You've arrived at the pharmacy!",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Let the pharmacist scan your QR-Code</BringzzText>
            <BringzzButton className='bg-magic-lilac mt-5' onClick={() => navigate('/qrcode')}>Identify yourself</BringzzButton>
        </div>
    },
    {
        status: "Wait for the pharmacist!",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Wait for the pharmacist to confirm the order</BringzzText>
        </div>
    },
    {
        status: "Take charge of the order!",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Scan the QR-Code on the order bag</BringzzText>
            <BringzzButton onClick={() => navigate('/camera/shopper/pickup/collect')} className='bg-magic-lilac mt-5'>Make collection</BringzzButton>
        </div>
    },
    {
        status: "Delivering order to customer...",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Drive bacl with the order to the customer</BringzzText>
            <BringzzButton className='bg-magic-lilac mt-5' onClick={() => navigate('/map')}>Get directions</BringzzButton>
        </div>
    },
    {
        status: "You've arrived at the customer!",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Identify yourself and hand over the order</BringzzText>
            <BringzzButton className='bg-magic-lilac mt-5' onClick={() => navigate('/qrcode')}>Identify yourself</BringzzButton>
        </div>
    },
    {
        status: "Handover the order to the customer",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Scan the QR-Code on the order bag to confirm that you have delivered the order.</BringzzText>
            <BringzzButton className='bg-magic-lilac mt-5' onClick={() => navigate('/camera/shopper/pickup/handover')}>Confirm handover</BringzzButton>
        </div>
    },
    {
        status: "Order completed!",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Order completed! Thank you for delivering the order.</BringzzText>
        </div>
    },
]

export const pharmacyPickupSegments = ({ navigate, processOrder, loading, orderDetails }) => [
    {
        status: "Get ready to prepare order...",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-18 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal mb-4"}>{"Time to prepare the order!"}</BringzzText>
            <BringzzButton
                className="bg-magic-lilac"
                onClick={() => processOrder()}
                disabled={loading}
            >Process Order</BringzzButton>
        </div>
    },
    {
        status: "Matching shopper...",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-18 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal mb-4"}>{"Waiting for a shopper to accept the order!"}</BringzzText>
        </div>
    },
    {
        status: "Shopper is on his way to the customer.",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-18 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal mb-4"}>{"Waiting for the shopper."}</BringzzText>
        </div>
    },
    {
        status: "Shopper arrived at the customer.",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-18 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal mb-4"}>{"Waiting for the shopper."}</BringzzText>
        </div>
    },
    {
        status: "Shopper on his way to you.",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-18 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal mb-4"}>{"Waiting for the shopper."}</BringzzText>
        </div>
    },
    {
        status: "Identify Shopper",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-18 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal mb-4"}>{"Scan the QR-Code on the shopper's phone."}</BringzzText>
            <BringzzButton onClick={() => navigate('/camera/pharmacy/pickup/identify')} className='bg-magic-lilac mt-5'>Identify Shopper</BringzzButton>
        </div>
    },
    {
        status: "Bring the order to the shopper",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-18 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal mb-4"}>{"Scan the bags to confirm that you have brought the order to the shopper."}</BringzzText>
            <BringzzButton onClick={() => navigate('/camera/pharmacy/pickup/collect')} className='bg-magic-lilac mt-5'>Confirm order</BringzzButton>
        </div>
    },
    {
        status: "Waiting for the shopper to confirm the order",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-18 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal mb-4"}>{"Waiting for the shopper to confirm the order."}</BringzzText>
        </div>
    },
    {
        status: "Get your invoice",
        subStatus: '',
        content: (
            <InvoiceStep 
                orderId={orderDetails?.id} 
                showDownload={false}
                onContinue={() => navigate('/matchmaking/pharmacy/completed')}
            />
        )
    },
    {
        status: "Order completed!",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-18 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal mb-4"}>{"Shopper on his way to the customer!"}</BringzzText>
        </div>
    },
]

export const pharmacyCollectSegments = ({ navigate, processOrder, loading, orderDetails }) => [
    // 0
    {
        status: "Get ready to prepare order...",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-18 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal mb-4"}>{"Time to prepare the order!"}</BringzzText>
            <BringzzButton
                className="bg-magic-lilac"
                onClick={() => processOrder()}
                disabled={loading}
            >Process Order</BringzzButton>
        </div>
    },
    // 1
    {
        status: "Customer is on his way to you.",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-18 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal mb-4"}>{"Waiting for the customer."}</BringzzText>
        </div>
    },
    // 2
    {
        status: "Customer arrived at the pharmacy.",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-18 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal mb-4"}>{"Scan the QR-Code on the customer's phone."}</BringzzText>
            <BringzzButton onClick={() => navigate('/camera/pharmacy/collect/identify')} className='bg-magic-lilac mt-5'>Identify customer</BringzzButton>
        </div>
    },
    // 3
    {
        status: "Customer identified, get his bag",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-18 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal mb-4"}>{"Scan the QR-Code on the order bag to confirm that you have brought the order to the customer."}</BringzzText>
            <BringzzButton onClick={() => navigate('/camera/pharmacy/collect/confirm')} className='bg-magic-lilac mt-5'>Confirm order</BringzzButton>
        </div>
    },
    // 4
    {
        status: "Waiting for the customer to confirm the order",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-18 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal mb-4"}>{"Waiting for the customer to confirm the order."}</BringzzText>
        </div>
    },
    // 5
    {
        status: "Get your invoice",
        subStatus: '',
        content: (
            <InvoiceStep 
                orderId={orderDetails?.id} 
                showDownload={false}
                onContinue={() => navigate('/matchmaking/pharmacy/completed')}
            />
        )
    },
    {
        status: "Order completed!",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-18 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal mb-4"}>{"Customer got his order successfully!"}</BringzzText>
        </div>
    },
]

export const pharmacyMailSegments = ({ navigate, processOrder, loading, courierArrived, orderDetails }) => [
    {
        status: "Get ready to prepare order...",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-18 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal mb-4"}>{"Time to prepare the order!"}</BringzzText>
            <BringzzButton
                className="bg-magic-lilac"
                onClick={() => processOrder()}
                disabled={loading}
            >Process Order</BringzzButton>
        </div>
    },
    {
        status: "Handover order to logistic partner...",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-18 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzButton onClick={() => navigate('/courier')} className='bg-magic-lilac mt-5'>Handover order</BringzzButton>
        </div>
    },
    {
        status: "Shipping in progress...",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-18 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal mb-4"}>{"Waiting for the courier to deliver the order."}</BringzzText>
            <BringzzButton onClick={() => courierArrived()} className='bg-magic-lilac mt-5'>Arrived</BringzzButton>
        </div>
    },
    {
        status: "Get your invoice",
        subStatus: '',
        content: (
            <InvoiceStep 
                orderId={orderDetails?.id} 
                showDownload={false}
                onContinue={() => navigate('/matchmaking/pharmacy/completed')}
            />
        )
    },
    {
        status: "Order completed!",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-18 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal mb-4"}>{"Customer got his order successfully!"}</BringzzText>
        </div>
    },
]

export const customerPickupSegments = ({ navigate, loading }) => [
    {
        status: "Matching pharmacy...",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Waiting for a pharmacy to accept request!</BringzzText>
        </div>
    },
    {
        status: "Order is being prepared",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Pharmacy matched! Your order is now
                being prepared.</BringzzText>
        </div>
    },
    {
        status: "Matching shopper...",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Order ready!</BringzzText>
            <BringzzText tag='h5' className={"font-normal"}>Now waiting for shopper to accept request...</BringzzText>
        </div>
    },
    {
        status: "Shopper is on his way...",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Shopper matched!</BringzzText>
            <BringzzText tag='h5' className={"font-normal"}>He is on his way to pick up your receipt from you...</BringzzText>
        </div>
    },
    {
        status: "Handover prescription...",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Time to handover your prescription!</BringzzText>
            <BringzzText tag='h5' className={"font-normal"}>{"Scan the QR-Code on your shopper's phone and handover the prescription."}</BringzzText>
            <BringzzButton onClick={() => navigate('/camera/customer/pickup/identify')} className='bg-magic-lilac mt-5'>Handover prescription</BringzzButton>
        </div>
    },
    {
        status: "Shopper on the way to the pharmacy",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            {/* <BringzzText tag='h4' className={"font-normal"}>Handover complete!</BringzzText> */}
            <BringzzText tag='h5' className={"font-normal"}>Your shopper is now on his way to pick up your order.</BringzzText>
        </div>
    },
    {
        status: "Shopper arrived at the pharmacy",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Waiting for shopper to identify himself</BringzzText>
        </div>
    },
    {
        status: "Shooper identified at the pharmacy",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Waiting for shopper to pickup your order</BringzzText>
        </div>
    },
    {
        status: "Pharmacist confirmed the order",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Order handed over to the shopper</BringzzText>
        </div>
    },
    {
        status: "Order picked up...",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Your order has been picker up!</BringzzText>
            <BringzzText tag='h5' className={"font-normal"}>Shopper is now on his way back to deliver your order..</BringzzText>
        </div>
    },
    {
        status: "Shopper has arrived...",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Shopper has arrived with your order!</BringzzText>
            <BringzzText tag='h5' className={"font-normal"}>Scan the QR-Code on the shopper phone to identify him.</BringzzText>
            <BringzzButton className='bg-magic-lilac mt-5' onClick={() => navigate('/camera/customer/pickup/identify')}>Identify shopper</BringzzButton>
        </div>
    },
    {
        status: "Ready for collection...",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Wait for the shopper to handover your order.</BringzzText>
        </div>
    },
    {
        status: "Confirm your order...",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Scan the QR-Code on your order bag to confirm that you have received the correct order.</BringzzText>
            <BringzzButton className='bg-magic-lilac mt-5' onClick={() => navigate('/camera/customer/pickup/confirm')}>Confirm delivery</BringzzButton>
        </div>
    },
    {
        status: "Order completed!",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Order completed!</BringzzText>
        </div>
    },
]

export const customerCollectSegments = ({ navigate, loading }) => [
    // 0
    {
        status: "Matching pharmacy...",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Waiting for a pharmacy to accept request!</BringzzText>
        </div>
    },
    // 1
    {
        status: "Order is being prepared",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Pharmacy matched! Your order is now
                being prepared.</BringzzText>
        </div>
    },
    // 2
    {
        status: "Order got ready",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Order is ready!</BringzzText>
            <BringzzButton className='bg-magic-lilac mt-5' onClick={() => navigate('/map')}>Get directions</BringzzButton>
        </div>
    },
    // 3
    {
        status: "You have arrived at the pharmacy",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h5' className={"font-normal"}>Identify yourself at the pharmacy to pick up your order.</BringzzText>
            <BringzzButton className='bg-magic-lilac mt-5' onClick={() => navigate('/qrcode/customer/collect/identify')}>Identify yourself</BringzzButton>
        </div>
    },
    // 4
    {
        status: "Wait for the pharmacist to confirm your order...",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Wait for the pharmacist to confirm your order.</BringzzText>
        </div>
    },
    // 5
    {
        status: "Confirm your order...",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Scan the QR-Code on your order bag to confirm that you have received the correct order.</BringzzText>
            <BringzzButton className='bg-magic-lilac mt-5' onClick={() => navigate('/camera/customer/collect/confirm')}>Confirm delivery</BringzzButton>
        </div>
    },
    // 6
    {
        status: "Order completed!",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Order completed!</BringzzText>
        </div>
    },
]

export const customerMailSegments = ({ navigate, loading }) => [
    // 0
    {
        status: "Matching pharmacy...",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Waiting for a pharmacy to accept request!</BringzzText>
        </div>
    },
    // 1
    {
        status: "Order is being prepared",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Pharmacy matched! Your order is now
                being prepared.</BringzzText>
        </div>
    },
    // 2
    {
        status: "Order got ready",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Order is being dispatched to a courier for shipment.</BringzzText>
        </div>
    },
    // 3
    {
        status: "Courier is on the way!",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h5' className={"font-normal"}>Waiting for the courier to deliver your order.</BringzzText>
        </div>
    },
    // 4
    {
        status: "Courier has arrived!",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Scan the QR-Code on your order bag to confirm that you have received the correct order.</BringzzText>
            <BringzzButton className='bg-magic-lilac mt-5' onClick={() => navigate('/camera/customer/mail/confirm')}>Confirm delivery</BringzzButton>
        </div>
    },
    // 5
    {
        status: "Order completed!",
        subStatus: '',
        content: <div className='flex flex-col text-center items-center border border-black rounded-lg pb-4 my-6'>
            <div className='flex justify-center'>
                <img className='h-24 w-24' src={RocketImage} alt='progress ing'></img>
            </div>
            <BringzzText tag='h4' className={"font-normal"}>Order completed!</BringzzText>
        </div>
    },
]